var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _path2, _rect7, _path3, _rect8, _rect9, _path4, _rect0, _path5, _rect1, _rect10, _rect11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.204638,
    y: 0.204638,
    width: 35.5906,
    height: 35.5906,
    rx: 17.7953,
    stroke: "white",
    strokeWidth: 0.409276
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.742,
    y: 9.7739,
    width: 1.37101,
    height: 1.37101,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.113,
    y: 11.1449,
    width: 1.37101,
    height: 2.74202,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.855,
    y: 16.629,
    width: 1.37101,
    height: 1.37101,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.226,
    y: 17.9999,
    width: 1.37101,
    height: 5.48403,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.226 23.484H24.855V24.855H23.484V26.226H26.226V23.484Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.371,
    y: 26.226,
    width: 4.11303,
    height: 1.37101,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.484 13.8869H24.855V16.6289H23.484V19.371H22.113V16.6289H19.371V15.2579H23.484V13.8869Z",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.629,
    y: 23.484,
    width: 2.74202,
    height: 2.74202,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6289 16.629H19.371V19.371H22.113V20.742H20.742V23.484H19.371V20.742H16.6289V23.484H15.2579V20.742H13.8869V19.371H16.6289V16.629Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.7739,
    y: 16.629,
    width: 1.37101,
    height: 1.37101,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.40289,
    y: 17.9999,
    width: 1.37101,
    height: 5.48403,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1449 23.484H9.7739V26.226H12.5159V24.855H11.1449V23.484Z",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5159,
    y: 26.226,
    width: 4.11303,
    height: 1.37101,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5159 13.8869H11.1449V16.6289H12.5159V19.371H13.8869V16.6289H16.6289V15.2579H12.5159V13.8869Z",
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5159,
    y: 11.1449,
    width: 1.37101,
    height: 2.74202,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8869,
    y: 9.7739,
    width: 1.37101,
    height: 1.37101,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2579,
    y: 8.40289,
    width: 5.48403,
    height: 1.37101,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d94d0fc1de5867c4e4e97b7a1406ab8e.svg";
export { ForwardRef as ReactComponent };